/**
 * Transition Design Tokens
 *
 * ⭐ MODIFY ANIMATIONS HERE
 * Change these values to update the entire app's animations
 */

export const transitions = {
  // Duration
  duration: {
    fast: '150ms',
    normal: '300ms',      // Default - CHANGE ME
    slow: '500ms',
  },

  // Easing
  easing: {
    default: 'cubic-bezier(0.4, 0, 0.2, 1)',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    out: 'cubic-bezier(0, 0, 0.2, 1)',
    inOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },

  // Common transitions
  button: 'all 150ms ease',
  card: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',   // CHANGE ME
  modal: 'opacity 300ms ease',
} as const;
